import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

type RatingScaleProps = {
  label: string;
  value?: number;
  onChange: (value: number) => void;
};

const RatingWrap = styled.div`
  display: grid;
  gap: 6px;
`;

const ScaleHintRow = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

const ScoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border: 1px solid ${(p) => p.theme.colors.primary300};
`;

const ScoreButton = styled.button<{ selected?: boolean }>`
  height: 34px;
  border: 0;
  border-right: 1px solid ${(p) => p.theme.colors.primary300};
  background: ${(p) => (p.selected ? p.theme.colors.primary300 : p.theme.colors.light)};
  color: ${(p) => (p.selected ? p.theme.colors.light : p.theme.colors.primary300)};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
  cursor: pointer;

  &:last-child {
    border-right: 0;
  }

  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primary500};
    outline-offset: 2px;
  }
`;

const RatingScale = ({ label, value, onChange }: RatingScaleProps) => {
  //   @ts-ignore
  const { t } = useTranslation();

  return (
    <RatingWrap>
      <ScaleHintRow>
        <span>{t('pbl.evaluation.lawyerCompletion.part3.poor', { defaultValue: 'Poor' })}</span>
        <span>{t('pbl.evaluation.lawyerCompletion.part3.excellent', { defaultValue: 'Excellent' })}</span>
      </ScaleHintRow>
      <ScoreGrid role="group" aria-label={label}>
        {[1, 2, 3, 4, 5].map((score) => (
          <ScoreButton
            key={score}
            type="button"
            selected={value === score}
            aria-label={`${label} ${score}`}
            aria-pressed={value === score}
            onClick={() => onChange(score)}
          >
            {score}
          </ScoreButton>
        ))}
      </ScoreGrid>
    </RatingWrap>
  );
};

export default RatingScale;
